import React from 'react';
import usePrices from '../../hooks/usePrices';
import { PAGES } from '../../site/routes';
import {
  usePageSeo, Breadcrumbs, PageHeader, Section, AllPriceTables, UpdatedNote, LinkCards, CtaBand
} from '../../site/ui';

const BREADCRUMBS = [
  { label: 'Accueil', to: PAGES.home },
  { label: 'Prix des Kamas', to: PAGES.prices },
];

export default function PricesPage() {
  const { servers, updatedAt } = usePrices();

  usePageSeo({
    title: "Prix des Kamas aujourd'hui au Maroc (DH/M) | AV Kamas",
    description: "Prix des Kamas en dirhams sur les 20 serveurs Dofus 3, Dofus Rétro et Dofus Touch, mis à jour en continu. Achat et vente au meilleur prix.",
    path: PAGES.prices,
    breadcrumbs: BREADCRUMBS,
  });

  return (
    <main className="bg-gray-950 text-white">
      <Breadcrumbs items={BREADCRUMBS} />
      <PageHeader
        kicker="Tarifs en direct"
        title={<>Prix des Kamas <span className="text-yellow-400">aujourd'hui</span></>}
        intro="Prix en dirhams pour 1 million de Kamas (1M), sur tous les serveurs officiels. « Vous achetez » est le prix que vous payez, « Vous vendez » est le prix que nous vous payons."
      />
      <Section className="pt-0 md:pt-0">
        <AllPriceTables servers={servers} />
        <UpdatedNote updatedAt={updatedAt} />
      </Section>
      <Section title="Pour aller plus loin" className="bg-gray-900/40">
        <LinkCards
          links={[
            { to: PAGES.comparison, title: 'Comparatif TryAndJudge', text: 'Voyez serveur par serveur combien vous gagnez par rapport à TryAndJudge.' },
            { to: PAGES.buyGuide, title: 'Achat Kamas Maroc', text: 'Comment acheter vos Kamas en dirhams, étape par étape.' },
            { to: PAGES.sellGuide, title: 'Vente Kamas Maroc', text: 'Comment vendre vos Kamas et être payé par virement en DH.' },
          ]}
        />
      </Section>
      <CtaBand />
    </main>
  );
}
